import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import type { ReactNode } from 'react';
import PaymentMethodsContext from '../payment-methods/context/PaymentMethodsContext';
import { usePayPal } from '../payment-methods/paypal/hooks/usePayPal';
import type { TransformedPaymentMethod } from '../models';
import Loading from '../../../common/loading/components/Loading';

interface PaymentPageProviderProps {
  children: ReactNode;
  paymentMethods: TransformedPaymentMethod[];
}

const PaymentPageProvider = ({ children, paymentMethods }: PaymentPageProviderProps) => {
  const { payPalSessionData, hasPaypalPaymentMethod, payPalScriptOptions } =
    usePayPal(paymentMethods);

  if (hasPaypalPaymentMethod && payPalSessionData === null) {
    return <Loading />;
  }

  return (
    <PayPalScriptProvider deferLoading options={payPalScriptOptions}>
      <PaymentMethodsContext>{children}</PaymentMethodsContext>
    </PayPalScriptProvider>
  );
};

export default PaymentPageProvider;
